import { useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { hasFullAppAccess } from '@/lib/authRedirect';

export type AppMode = 'oposiciones' | 'oposiciones_c1' | 'oposiciones_guardia_civil' | 'oposiciones_policia_nacional' | 'oposiciones_iipp' | 'oposiciones_c2' | 'oposiciones_generico' | 'base_comun' | 'funcionarios';

/**
 * Hook que determina el modo efectivo de la aplicación.
 */
export function useEffectiveMode(): AppMode {
  const { profile, isLoading } = useAuth();
  const location = useLocation();
  
  // Prioritize URL-based detection (essential for refresh/initial load)
  const path = location.pathname;
  if (path.includes('/oposiciones-c1')) return 'oposiciones_c1';
  if (path.includes('/oposiciones-c2')) return 'oposiciones_c2';
  if (path.includes('/oposiciones-iipp')) return 'oposiciones_iipp';
  if (path.includes('/guardia-civil')) return 'oposiciones_guardia_civil';
  if (path.includes('/policia-nacional')) return 'oposiciones_policia_nacional';
  if (path.includes('/base-comun')) return 'oposiciones_generico';
  if (path.includes('/oposiciones')) return 'oposiciones';

  // Fallback to profile-based detection if not in a specific URL path
  if (hasFullAppAccess(profile)) {
    return 'funcionarios';
  }

  const plan = profile?.plan;
  if (plan === 'oposiciones_c1') return 'oposiciones_c1';
  if (plan === 'oposiciones_c2') return 'oposiciones_c2';
  if (plan === 'oposiciones_iipp') return 'oposiciones_iipp';
  if (plan === 'oposiciones_guardia_civil') return 'oposiciones_guardia_civil';
  if (plan === 'oposiciones_policia_nacional') return 'oposiciones_policia_nacional';
  return plan === 'oposiciones' ? 'oposiciones' : 'funcionarios';
}
